import { formatTonsWithUnit } from "./resultsFleetData.js";

// Chargements à la suite : chargements faits l'un après l'autre, avant les livraisons
// (voir components/JoinedLoadsTimelineMarks.jsx).

function describeLoadBlock(item) {
  const members = item?.kind === "group" ? item.memberSegments || [] : [item?.segment];
  if (!members.length || members.some((segment) => segment?.stopType !== "loading")) {
    return null;
  }
  const compartmentIds = members.flatMap((segment) => (segment.compartmentAllocations || []).map((allocation) => allocation?.compartment_id));
  return {
    item,
    leftPercent: Number((item.kind === "group" ? item : item.segment).leftPercent) || 0,
    label: members[0].operationLabel || "",
    joinedOrderIds: members[0].joinedLoadOrderIds || [],
    orderIds: members.map((segment) => segment.operationOrderId).filter(Boolean),
    stepIds: members.map((segment) => segment.segmentReorder?.stepId).filter(Boolean),
    tons: members.reduce((total, segment) => total + (Number(segment.quantityTons) || 0), 0),
    compartmentIds: new Set(compartmentIds.filter(Boolean)),
    compartments: new Set(compartmentIds.filter(Boolean)).size,
  };
}

function formatLoadSummary(tons, compartments) {
  return `${formatTonsWithUnit(tons, { unit: "t" })} · ${compartments} compartiment${compartments > 1 ? "s" : ""}`;
}

// Jonctions entre deux blocs d'un même groupe (un bloc = un segment ou un groupe du Gantt).
export function buildJoinedLoadJunctions(items = []) {
  const blocks = items.map(describeLoadBlock);
  return blocks.flatMap((block, index) => {
    const previous = blocks[index - 1];
    if (!block || !previous || !block.orderIds.some((orderId) => previous.joinedOrderIds.includes(orderId))) {
      return [];
    }
    const groupBlocks = blocks.filter((candidate) => candidate?.orderIds.some((orderId) => block.joinedOrderIds.includes(orderId)));
    const rows = groupBlocks.map((groupBlock) => [groupBlock.label, formatLoadSummary(groupBlock.tons, groupBlock.compartments)]);
    rows.push(
      ["Total", formatLoadSummary(
        groupBlocks.reduce((total, groupBlock) => total + groupBlock.tons, 0),
        // Un compartiment partagé entre deux chargements n'est compté qu'une fois.
        new Set(groupBlocks.flatMap((groupBlock) => [...groupBlock.compartmentIds])).size,
      )],
      ["Livraisons", `après ${groupBlocks[groupBlocks.length - 1].label}`],
    );
    return [{ key: `joined-loads:${block.item.key}`, leftPercent: block.leftPercent, rows }];
  });
}

// Bloc survolé en mode « charger à la suite » pendant un glisser.
export function resolveJoinedLoadDropTarget(items = [], dragState = null) {
  if (dragState?.hoveredPlacement !== "join") {
    return null;
  }
  return items.map(describeLoadBlock).find((block) => block && (
    block.stepIds.includes(dragState.hoveredStepId)
    || (dragState.hoveredGroupKey && block.item.groupKey === dragState.hoveredGroupKey)
  )) || null;
}
